<app-activity
  *ngIf="id"
  [model]="'billing/orders'"
  [modelId]="id"
></app-activity>
